import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  files: {
    data: [],
    currentPage: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    getfileSuccess: (state, action) => {
      state.files = action.payload;
      state.loading = false;
    },
    startLoadingfile: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getfiles = ({ accessToken, filters={} }) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoadingfile());
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API}/get-all-files?startDate=${filters?.startDate}&&endDate=${filters?.endDate}`, { headers });
      dispatch(slice.actions.getfileSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};

